<template>
  <div id="edit-modal-company" class="modal modal-fixed-footer" ref="editModal">
    <div class="modal-content">
      <div class="processing-overlay" v-if="isProcessing">
        <!-- isProcessing -->
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>

      <input
        type="file"
        @change="$_addImage"
        ref="file"
        style="display: none"
        accept="application/pdf,"
        multiple
      />

      <pdf-block :data-file="showPdf" v-if="showPdf" />

      <div
        class="row flex-row"
        style="margin-bottom: 0px !important;"
        v-if="!showPdf"
      >
        <div class="col s12" v-if="!hasImagesX">
          <div class="valign-wrapper">
            <div class="no-image">
              <i class="material-icons grey-text text-darken-2">upload_file</i>
            </div>
          </div>
        </div>
        <div
          class="col s6 m2 preview-image"
          v-for="(image, index) in images"
          :key="index"
        >
          <div class="btn-wrapper">
            <button
              class="btn-floating btn-small white waves-effect"
              @click="$_deleteImage(index)"
            >
              <i class="material-icons-outlined grey-text text-darken-3">
                delete
              </i>
            </button>
            <button
              class="btn-floating btn-small white waves-effect"
              v-if="!image.isNew"
              @click="$_viewPdf(image)"
            >
              <i class="material-icons-outlined grey-text text-darken-3">
                visibility
              </i>
            </button>
          </div>
          <div class="image">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <path
                style="fill:#E2E5E7;"
                d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
              />
              <path
                style="fill:#B0B7BD;"
                d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
              />
              <polygon
                style="fill:#CAD1D8;"
                points="480,224 384,128 480,128 "
              />
              <path
                style="fill:#F15642;"
                d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16
	V416z"
              />
              <g>
                <path
                  style="fill:#FFFFFF;"
                  d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48
		c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z
		 M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"
                />
                <path
                  style="fill:#FFFFFF;"
                  d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296
		c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"
                />
                <path
                  style="fill:#FFFFFF;"
                  d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68
		h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912
		c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"
                />
              </g>
              <path
                style="fill:#CAD1D8;"
                d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
              />
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
        </div>
        <div class="col s12 center-align">
          <button
            class="btn grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
            @click="$_openFile()"
            v-if="!hasImagesX"
          >
            <i class="material-icons-outlined right grey-text text-darken-3"
              >add</i
            >
            Click to upload file
          </button>
        </div>
        <div class="clear"></div>
        <div class="special-guidelines">
          <div class="card z-depth-0 grey lighten-4">
            <div class="card-content">
              <b>Note</b>: The file format must be PDF. You cannot upload more
              than 1 file.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        @click="$_close()"
        class="btn-flat red-text text-darken-4 waves-effect"
      >
        Close
      </button>
      <button
        @click="$_saveImage()"
        :disabled="!canSaveX"
        class="btn-flat green-text waves-effect"
      >
        Save
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";

import axios from "axios";
import { getCookie } from "@/common/util";
import { deleteMediaFile, updateUserProfile } from "@/api/user.api";
import { mapActions } from "vuex";
import { toastMessage } from "../../common/util";
import PdfBlock from "@/components/pdfBlock.component.vue";
export default {
  name: "AdaptationFileModal",
  components: {
    PdfBlock,
  },
  props: {
    dataAction: {
      type: String,
      default: "",
    },
    dataDocuments: {
      type: Array,
      default: () => false,
    },
    dataKey: String,
  },
  data() {
    return {
      addingMore: false,
      modal: {
        instance: null,
        options: {
          dismissible: false,
        },
      },
      showPdf: false,
      editData: {},
      editAcfData: {},
      isProcessing: false,
      image: null,
      previewImage: null,
      name: "",
      address: "",

      images: [],
    };
  },
  beforeDestroy() {
    if (this.modal.instance !== null) {
      this.modal.instance.close();
      setTimeout(() => {
        this.modal.instance.destroy();
      }, 90);
    }
  },
  watch: {
    dataDocuments() {
      this.$_setImages();
    },
  },
  computed: {
    canSaveX() {
      const val = this.images.filter(({ isNew, shouldDel }) => isNew);
      return val.length > 0;
    },
    hasImagesX() {
      return this.images.length > 0;
    },
    // imagesX() {
    //   return this.images.filter(({ shouldDel }) => !shouldDel);
    // },
  },
  mounted() {
    this.$_initModal();
    this.$_setImages();
  },
  methods: {
    ...mapActions("User", ["updateUser"]),
    $_viewPdf(file) {
      this.showPdf = file.link;
    },
    $_initModal() {
      this.modal.instance = M.Modal.init(
        this.$refs.editModal,
        this.modal.options
      );
      setTimeout(() => {
        this.modal.instance.open();
      });
    },
    $_setImages() {
      if (this.dataDocuments[0] && this.dataDocuments[0].link) {
        this.images = [{ isNew: false, ...this.dataDocuments[0] }];
      }
    },
    $_openFile() {
      this.$refs.file.click();
      this.addingMore = true;
    },
    $_addImage($event) {
      const files = $event.target.files;

      Object.keys(files).some((key) => {
        if (files[key].size > 5 * 1024 * 1024) {
          toastMessage("Maximum file size is 5MB.");
          return true;
        }

        if (files[key].type !== "application/pdf") {
          toastMessage("PDF file only.");
          return true;
        }
        const imageObj = {
          isNew: true,
          image: files[key],
        };

        this.images.push(imageObj);
      });
    },
    $_setImage($event) {
      const file = $event.target.files[0];
      this.previewImage = URL.createObjectURL(file);
      this.image = file;
    },
    async $_deleteImage(index) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      if (this.images[index].isNew) {
        this.images = this.images.filter((_, i) => i !== index);
        this.isProcessing = false;
        this.$refs.file.value = "";
        return;
      }

      try {
        const idx = this.images[index].id;
        await deleteMediaFile(idx);

        this.images = this.images.filter((_, i) => i !== index);

        this.$refs.file.value = "";
        let payload = {
          fields: {
            adaptation_plan_document: "",
          },
        };

        await this.$_updateUserProfile(
          this.$store.state.User.user.profile,
          payload
        );
        this.$emit("refresh");
        this.isProcessing = false;
      } catch (error) {
        this.isProcessing = false;
      }
    },
    async $_updateUserProfile(profile, payload) {
      await updateUserProfile(profile, payload)
        .then((res) => {
          this.updateUser({ ...payload.fields });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async $_saveImage() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      const token = getCookie("token");

      let formData = new FormData();
      const image = this.images[0];
      const newName = new Date().getTime() + image.image.name;
      formData.append("file", image.image, newName);

      const { data } = await axios.post(
        "https://api.sldb.lc/wp-json/wp/v2/media",
        formData,
        {
          headers: {
            Authorization: "Bearer" + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (data) {
        const dataObj = [
          Object.assign({}, this.dataDocuments[0], {
            id: data.id,
            link: data.source_url,
          }),
        ];

        let payload = {
          fields: {
            adaptation_plan_document: JSON.stringify(dataObj),
          },
        };

        await this.$_updateUserProfile(
          this.$store.state.User.user.profile,
          payload
        );

        this.$emit("refresh");
      }

      this.isProcessing = false;

      this.$_setImages();
    },
    $_close() {
      this.modal.instance.close();
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
#edit-modal-company {
  border-radius: 10px;

  .special-guidelines {
    width: 100%;
  }

  .no-image {
    width: 96px;
    height: 96px;
    text-align: center;
    line-height: 96px;
    margin: auto;
    background: #f6f6f6;
    border-radius: 50%;
    margin-bottom: 16px;
    i {
      font-size: 48px;
      line-height: 96px;
    }
  }
}
.flex-row {
  // display: inline-flex;
  // flex-wrap: wrap;
  .col {
    &.preview-image {
      margin-left: 0px;
      position: relative;
      margin-right: 0px;

      .btn-wrapper {
        position: absolute;
        width: calc(100% - 12px);
        text-align: center;
        // left: 50%;
        // transform: translateX(-50%);
        bottom: 24px;
        button:first-of-type {
          margin-right: 5px;
        }
      }
    }
    .image {
      border-radius: 8px;
      overflow: hidden;
      padding: 10px;
      border: 1px solid #e9e9e9;
      text-align: center;
      svg {
        height: 80px;
      }
    }
  }
}
.processing-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
  .preloader-wrapper {
    left: 50%;
    top: 50%;
    z-index: 9;
    margin-left: -18px;
    margin-top: -18px;
  }
}

.preview-image {
  position: relative;
  margin-bottom: 1rem;
}
</style>
